import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchLogs = createAction(ACTION.FETCH_LOGS.REQUEST, (object, object_id, filter = {}) => ({object, object_id, filter}));
export const clearState = createAction(ACTION.CLEAR_STATE);
